import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setRefreshing(state, payload) {
    state.isRefreshing = payload;
  },
  setAdding(state, payload) {
    state.isAdding = payload;
  },
  setItems(state, payload) {
    state.list = payload;
  },
  addItems(state, payload) {
    state.list.push(...payload);
  },
  setPaging(state, payload) {
    state.paging = payload;
  },
  setStatuses(state, payload) {
    state.statuses = payload;
  },
  setSummary(state, payload) {
    state.summary = payload;
  },
};
